import { IconShieldCheck } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";
import { ClaimStatusChip } from "../../../warranty-claims/presentation/components/claim-status-chip";
import { formatRelativeTime } from "./dashboard-helpers";
import { EmptyRow } from "./empty-row";
import type { WarrantyClaimDto } from "../../../../api";

const CLAIM_TYPE_LABELS: Record<string, string> = {
  DAMAGE: "Damage",
  DEFECT: "Defect",
  MISSING_PART: "Missing part",
  DOES_NOT_MATCH_DESCRIPTION: "Does not match description",
  PRODUCT_DEFECT: "Product defect",
  MISSING_ITEMS: "Missing items",
  DAMAGED_IN_TRANSIT: "Damaged in transit",
  WRONG_ITEM: "Wrong item",
  EXPIRED_PRODUCT: "Expired product",
  OTHER: "Other",
};

export function RecentClaimsSection({
  claims,
  onClickClaim,
}: {
  claims: WarrantyClaimDto[];
  onClickClaim: (id: string) => void;
}) {
  if (claims.length === 0) {
    return <EmptyRow icon={IconShieldCheck} title="No warranty claims received." />;
  }

  return (
    <>
      {claims.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={() => onClickClaim(c.id)}
          className="group flex w-full items-center gap-3 rounded-2xl border border-borderDefault bg-bgWhite px-4 py-3 text-left transition-colors hover:border-accentCyan"
        >
          <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-bgLight">
            <IconShieldCheck size={20} className="text-textMuted" />
          </div>
          {/* Phones: the status chip drops under the claim so the text keeps its width. */}
          <div className="flex min-w-0 flex-1 items-center gap-3 max-md:flex-col max-md:items-start max-md:gap-1.5">
            <div className="flex min-w-0 flex-1 flex-col gap-0.5 max-md:w-full">
              <Text variant="bodyBold" tone="dark" className="truncate">
                Claim #{c.id.slice(0, 8).toUpperCase()}
              </Text>
              <Text variant="bodySm" tone="muted">
                {CLAIM_TYPE_LABELS[c.claimType] ?? c.claimType} · {formatRelativeTime(c.createdAt)}
              </Text>
            </div>
            <ClaimStatusChip status={c.status} />
          </div>
        </button>
      ))}
    </>
  );
}
